export const SupportFab = (parentElement, onClick) => {
    // 1. Container
    const container = document.createElement('div');
    container.id = 'support-fab-container';
    container.className = 'fixed bottom-24 right-6 z-[9990] transition-transform duration-300 hover:scale-105';
    container.style.display = 'none'; // Hidden initally
    container.style.opacity = '0'; // Extra safety against flash

    // 2. Button
    const button = document.createElement('button');
    button.className = 'w-14 h-14 bg-indigo-600 hover:bg-indigo-700 text-white rounded-full shadow-lg flex items-center justify-center transition-colors focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500';
    button.innerHTML = `
        <span class="material-symbols-outlined text-2xl">support_agent</span>
    `;

    // 3. New Reply Badge
    const badge = document.createElement('span');
    badge.className = 'absolute -top-1 -right-1 bg-red-500 text-white text-xs font-bold px-2 py-0.5 rounded-full hidden';
    badge.innerText = 'N';

    button.appendChild(badge);
    container.appendChild(button);
    parentElement.appendChild(container);

    // 4. Click Handler
    button.onclick = onClick;

    // 5. Visibility Logic (Matches Safe Start logic)
    // We export a show method to be called by the parent after checks
    const api = {
        show: () => {
            container.style.display = 'block';
            // Trigger reflow to enable transition
            requestAnimationFrame(() => {
                container.style.opacity = '1';
                container.classList.add('animate-bounce-in');
            });
        },
        hide: () => {
            container.style.display = 'none';
        },
        showBadge: (show) => {
            if (show) badge.classList.remove('hidden');
            else badge.classList.add('hidden');
        },
        destroy: () => {
            container.remove();
        }
    };

    return api;
};
